<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56 56"
    fill="none"
    class="pe-icon-arrow"
    :class="{ 'pe-icon-rotate': direction === 'right' }"
    aria-hidden="true"
  >
    <path
      d="M26.3072 35.6152L18 27.1152L26.3072 18.6152M19.1543 27.1152H36"
      class="arrow-stroke"
      stroke-width="2.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    
    <path
      d="M49 27.6152C49 16.0215 39.5938 6.61523 28 6.61523C16.4062 6.61523 7 16.0215 7 27.6152C7 39.209 16.4062 48.6152 28 48.6152C39.5938 48.6152 49 39.209 49 27.6152Z"
      stroke="url(#pe_arrow_gradient)" 
      stroke-width="2.75"
      stroke-miterlimit="10"
    />
    
    <defs>
      <linearGradient
        id="pe_arrow_gradient"
        x1="28"
        y1="6.61523"
        x2="28"
        y2="48.6152"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="grad-start" />
        <stop offset="1" class="grad-end" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  direction: {
    type: String,
    default: 'left', // 'left' | 'right'
    validator: (val) => ['left', 'right'].includes(val)
  }
});
</script>

<style scoped>
.pe-icon-arrow {
  /* Tamaño por defecto, configurable desde el padre */
  width: var(--pe-icon-arrow-size, 1em); 
  height: var(--pe-icon-arrow-size, 1em);
  transition: transform 0.3s ease;
}

/* Rotación para botón "Siguiente" */
.pe-icon-rotate {
  transform: rotate(180deg);
}

/* --- MAPEO DE COLORES A VARIABLES --- */

/* 1. Color de la flecha interna */
.arrow-stroke {
  stroke: var(--pe-arrow-color, #00C3A8);
}

/* 2. Color inicio gradiente (stop 1) */
.grad-start {
  stop-color: var(--pe-arrow-grad-start, #00B79E);
}

/* 3. Color fin gradiente (stop 2) */
.grad-end {
  stop-color: var(--pe-arrow-grad-end, #03ECCB);
}
</style>